export const TAB_BAR_HEIGHT = 50;
export const TOAST_DURATION_IN_MS = 3000;
export const TOAST_ANIMATION_DURATION_IN_MS = 300;
export const TOAST_WIDTH_WEB = 356;

// Responsive breakpoints
export const MOBILE_BREAKPOINT = 768;

// Reachable before patient data loads, so shared with the provider.
export const MFA_ENROLMENT_ROUTE = "/(authed)/registration/mfa-phone";
export const MFA_VERIFY_ROUTE = "/(authed)/registration/mfa-verify";
export const MFA_ENROLMENT_PATHNAME = "/registration/mfa-phone";

export const MFA_ENROLMENT_PATHNAMES = [
  "/registration/mfa-phone",
  "/registration/mfa-verify",
];

// Session Timeout
export const SESSION_IDLE_TIMEOUT_MS = 15 * 60 * 1000;
export const SESSION_WARNING_BEFORE_TIMEOUT_MS = 5 * 60 * 1000;

// Native Languages
export const ENGLISH_NATIVE_TITLE = "English";
export const SPANISH_NATIVE_TITLE = "Español";
export const CHINESE_SIMPLIFIED_NATIVE_TITLE = "简体中文";
export const VIETNAMESE_NATIVE_TITLE = "Tiếng Việt";
export const RUSSIAN_NATIVE_TITLE = "Русский";
export const ARABIC_NATIVE_TITLE = "العربية";
export const TAGALOG_NATIVE_TITLE = "Tagalog";
export const HAITIAN_CREOLE_NATIVE_TITLE = "Kreyòl Ayisyen";

// Support
export const SUPPORT_EMAIL = "support@pointcare.com";
export const SUPPORT_PHONE_NUMBER = "1-833-234-7833";
export const SUPPORT_PHONE_NUMBER_URL = "tel:+18332347833";

// Offered when a patient declines the broker handoff
export const MEDICARE_SELF_ENROLLMENT_URL = "https://www.medicare.gov/";
export const MARKETPLACE_SELF_ENROLLMENT_URL = "https://www.healthcare.gov/";

// Email domain used to gate internal-only tooling to specific staff accounts
export const INTERNAL_MINDSEA_EMAIL_DOMAIN = "@mindsea.com";
export const INTERNAL_POINTCARE_EMAIL_DOMAIN = "@pointcare.com";

// SSO Auth error codes
export const SSO_ERROR_REQUEST_CANCELED = "ERR_REQUEST_CANCELED";
export const SSO_ERROR_POPUP_CLOSED = "auth/popup-closed-by-user";
